import { defineComponent as _defineComponent } from 'vue'
import FireOutbreakCard from '../FireOutbreakCard.vue'
import CustomFireOutbreakMarker from '../CustomFireOutbreakMarker.vue'
import EmptyFireOutbreakList from '../EmptyFireOutbreakList.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import { useRegistryUtils } from '@/composables/useRegistryUtils'
import { inject, ref, watch } from 'vue'
import { FireRiskDashboardViewModel } from '../../viewmodels/FireRiskDashboard.viewmodel'
import { FireOutbreakReactionEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import { ShareFireOutbreakAlertEnum } from '../../enums/ShareFireOutbreakAlert.enum'
import { FireOutbreak } from '@/@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import MapBoxMap from '@/@web/ui/components/map/MapBoxMap.vue'
import MapBoxMarker from '@/@web/ui/components/map/MapBoxMarker.vue'
import MapBoxZoomControl from '../../../../ui/components/map/MapBoxZoomControl.vue'
import MapBoxDrawLineControl from '../../../../ui/components/map/MapBoxDrawLineControl.vue'
import MapBoxFullscreenControl from '../../../../ui/components/map/MapBoxFullscreenControl.vue'
import MapBoxLayer from '../../../../ui/components/map/MapBoxLayer.vue'
import MapBoxSource from '../../../../ui/components/map/MapBoxSource.vue'
import MapInfoToggle from '../../../@shared/components/MapInfoToggle.vue'
import SimpleTextMarker from '../../../../ui/components/map/SimpleTextMarker.vue'
import { MapFillLayerFactory } from '../../../../ui/components/map/factories/MapFillLayer.factory'
import { MapOutlineLayerFactory } from '../../../../ui/components/map/factories/MapOutlineLayer.factory'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireAlertMap.view',
  setup(__props) {

const vm = inject<FireRiskDashboardViewModel>('fire-risk-dashboard-viewmodel')!

const {
	pageData: alerts,
	page: alertsPage,
	pageSize: alertsPageSize,
	onPageChange: alertsOnPageChange,
} = useRegistryUtils(vm.mapFireOutbreaks, [])

alertsPageSize.value = 4

function handleReaction(reaction: FireOutbreakReactionEnum, alertId: string) {
	vm.rateFireOutbreak(reaction, alertId)
}

function handleShare(share: ShareFireOutbreakAlertEnum, alert: FireOutbreak) {
	vm.handleShareFireOutbreakAlert(share, alert)
}

const rerender = ref(Math.random())

watch(vm.mapFireOutbreaks, () => (rerender.value = Math.random()), { deep: true })

return { __sfc: true,vm, alerts, alertsPage, alertsPageSize, alertsOnPageChange, handleReaction, handleShare, rerender, FireOutbreakCard, CustomFireOutbreakMarker, EmptyFireOutbreakList, Pagination, MapBoxMap, MapBoxMarker, MapBoxZoomControl, MapBoxDrawLineControl, MapBoxFullscreenControl, MapBoxLayer, MapBoxSource, MapInfoToggle, SimpleTextMarker, MapFillLayerFactory, MapOutlineLayerFactory }
}

})